import * as React from "react";

export const ContentPrimary: React.SFC<React.HTMLAttributes<HTMLDivElement>> = (props) => {
    return <div id="content-primary" { ...props }>
        {props.children}
    </div>;
};

export const ContentSecondary: React.SFC<React.HTMLAttributes<HTMLDivElement>> = (props) => {
    return <div id="content-secondary" { ...props }>
        {props.children}
    </div>;
};



// WEBPACK FOOTER //
// ./src/components/layout/Content.tsx